import type {LoanCategory} from 'src/typings';
import type {LoanCategoryDataService} from './loan-category.data-service';

export class KpLoanCategoriesPresenter {
    public static presenterName = 'kpLoanCategoriesPresenter';

    /*@ngInject*/
    constructor(private loanCategoryDataService: LoanCategoryDataService) {
    }

    public async getAll(): Promise<LoanCategory[]> {
        return this.loanCategoryDataService.getAll();
    }


}